import React, { useState } from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar'
import Shape from '../../images/Shape.png';
import Menu from '../../images/Menu.png';
import UserProfile from '../../images/UserProfile.png';
import Bell from '../../images/Bell.png';
import Cart from '../../images/Cart.png';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/esm/Button";
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import CloseButton from 'react-bootstrap/CloseButton'

function NavBar() {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <div>
            <Nav className="justify-content-center"
                activeKey="/home"
                onClick={handleShow}
                style={{
                    alignItems: 'center'
                }}
            >
                {/* Modal Starts */}
                <Modal
                    show={show}
                    onHide={handleClose}

                    style={{
                        marginTop: '140px',
                        height: '235px',
                        borderRadius: '20px !important'
                    }}>
                    <Modal.Header >
                        <CloseButton onClick={handleClose} />
                    </Modal.Header>
                    <Modal.Body style={{
                        marginBottom: '30px'
                    }}>Hi Shawn, <br></br> <br></br>


                        You have a new message from Lana. </Modal.Body>
                    <Button variant="success" size="lg" type="submit" style={{
                        height: '44.7px',
                        width: '151px',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        borderRadius: '0',
                        color: '#FFFFFF',
                        backgroundColor: '#00A78A',
                        marginBottom: '30px',
                        marginLeft: '15px'
                    }} >
                        VIEW MESSAGE
                    </Button>

                </Modal>
                {/* Modal Ends */}

                <Nav.Item>
                    {/* <Nav.Link eventKey="link-1">Link</Nav.Link> */}
                    <img src={Menu} style={{ width: '18px', height: '10px' }} alt="" />
                </Nav.Item>
                <Nav.Item>
                    {/* <Nav.Link eventKey="link-2">Link</Nav.Link> */}
                    <img src={UserProfile} style={{ width: '29.89px', height: '25.67px' }} alt="" />
                </Nav.Item>
                <Nav.Item style={{
                    marginRight: '50px', marginLeft: '50px', textAlign: 'center'
                }}>
                    <Navbar.Brand href="#home">
                        <img src={Shape} style={{ width: '65px', height: '17px', marginTop: '12px', marginRight: '3px', marginLeft: '15px', textAlign: 'center' }} alt="" />
                    </Navbar.Brand>
                    <Nav.Link href="/home"></Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="link-1">
                        <img src={Bell} style={{ width: '15.54px', height: '18.32px' }} alt="" />
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    {/* <Nav.Link eventKey="link-2">Link</Nav.Link> */}
                    <img src={Cart} style={{ width: '19.36px', height: '17.38px', }} alt="" />
                </Nav.Item>

            </Nav>
        </div >
    );
}
export default NavBar;